class YotpoPlpRating extends HTMLElement {
  constructor() {
    super();
    this._observer = null;
  }

  connectedCallback() {
    this.productId = this.getAttribute("data-product-id");
    this.productUrl = this.getAttribute("data-product-url");
    this.apiKey = "MXPSYzN6TjRTV9vBfTgp6hxWuAwztAXxuRQkEt9n";
    if (!this.productId || !this.apiKey) {
      console.error("Missing product id or api key.");
      return;
    }

    if ("IntersectionObserver" in window) {
      this._observer = new IntersectionObserver(
        (entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          this._observer.disconnect();
          this._scheduleFetch();
        },
        { rootMargin: "200px 0px" }
      );
      this._observer.observe(this);
      return;
    }

    this._scheduleFetch();
  }

  disconnectedCallback() {
    if (this._observer) this._observer.disconnect();
  }

  _scheduleFetch() {
    const run = () => this.fetchRating();
    if (window.requestIdleCallback) {
      window.requestIdleCallback(run, { timeout: 2500 });
    } else {
      window.setTimeout(run, 100);
    }
  }

  async fetchRating() {
    try {
      const response = await fetch(
        `https://api-cdn.yotpo.com/v3/storefront/store/${this.apiKey}/product/${this.productId}/reviews?perPage=1`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      if (!response.ok) {
        throw new Error("Failed to fetch rating data.");
      }
      const data = await response.json();
      const average_score = data.bottomline.averageScore;
      const total_reviews = data.bottomline.totalReview;
      if (average_score) {
        this.renderHtml(average_score, total_reviews);
      }
    } catch (e) {
      console.error("Error loading rating.", e);
    }
  }

  _renderStars(rating) {
    const stars = [];
    let roundedRating = Math.round(rating * 2) / 2;
    for (let i = 0; i < 5; ++i) {
      let className = "star-container";
      let marginEnd = i < 4 ? "3.5px" : "8px";
      let starType = "";
      if (roundedRating >= i + 1) {
        className += " yotpo-sr-star-full";
        starType = "full";
      } else if (roundedRating >= i + 0.5) {
        className += " yotpo-sr-star-half";
        starType = "half";
      } else {
        className += " yotpo-sr-star-empty";
        starType = "empty";
      }
      if (starType === "full") {
        stars.push(/*html*/ `
          <svg aria-hidden="true" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" class="${className}" width="15" height="15" style="display: flex; flex-direction: row; margin-inline-end: ${marginEnd};">
            <path style="pointer-events: none;" d="M9 14.118L14.562 17.475L13.086 11.148L18 6.891L11.529 6.342L9 0.375L6.471 6.342L0 6.891L4.914 11.148L3.438 17.475L9 14.118Z" stroke="rgba(166,92,65,1)" fill="rgba(166,92,65,1)"></path>
          </svg>
        `);
      } else if (starType === "half") {
        stars.push(/*html*/ `
          <svg aria-hidden="true" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" class="${className}" width="15" height="15" style="display: flex; flex-direction: row; margin-inline-end: ${marginEnd};">
            <defs>
              <linearGradient id="yotpo_half_star_${i}" x1="0" x2="1" y1="0" y2="0">
                <stop offset="50%" stop-color="rgba(166,92,65,1)"></stop>
                <stop offset="50%" stop-color="#E6E6E6"></stop>
                <stop offset="100%" stop-color="#E6E6E6"></stop>
              </linearGradient>
            </defs>
            <path style="pointer-events: none;" d="M9 14.118L14.562 17.475L13.086 11.148L18 6.891L11.529 6.342L9 0.375L6.471 6.342L0 6.891L4.914 11.148L3.438 17.475L9 14.118Z" stroke="rgba(166,92,65,1)" fill="url(#yotpo_half_star_${i})"></path>
          </svg>
        `);
      } else {
        stars.push(/*html*/ `
          <svg aria-hidden="true" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" class="${className}" width="15" height="15" style="display: flex; flex-direction: row; margin-inline-end: ${marginEnd};">
            <path style="pointer-events: none;" d="M9 14.118L14.562 17.475L13.086 11.148L18 6.891L11.529 6.342L9 0.375L6.471 6.342L0 6.891L4.914 11.148L3.438 17.475L9 14.118Z" stroke="rgba(166,92,65,1)" fill="#E6E6E6"></path>
          </svg>
        `);
      }
    }
    return stars.join("");
  }

  renderHtml(score, count) {
    const displayScore = Math.round(score * 10) / 10;
    this.innerHTML = `
      <a href="${
        this.productUrl
      }" aria-hidden="true" style="display: flex; flex-direction: row; align-items: center; height: 28px; cursor: pointer;">
        ${this._renderStars(score)}
        <span class="yotpo-plp-rating-score">${displayScore}</span>
        <span class="yotpo-plp-rating-total">(${count})</span>
      </a>
    `;
  }
}

customElements.define("yotpo-plp-rating", YotpoPlpRating);
